import { render, staticRenderFns } from "./PygameRecord.vue?vue&type=template&id=355e2314&scoped=true"
import script from "./PygameRecord.vue?vue&type=script&lang=js"
export * from "./PygameRecord.vue?vue&type=script&lang=js"
import style1 from "./PygameRecord.vue?vue&type=style&index=1&id=355e2314&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355e2314",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('355e2314')) {
      api.createRecord('355e2314', component.options)
    } else {
      api.reload('355e2314', component.options)
    }
    module.hot.accept("./PygameRecord.vue?vue&type=template&id=355e2314&scoped=true", function () {
      api.rerender('355e2314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/teacher/components/PygameRecord.vue"
export default component.exports